import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../../../core/constants/api-routes';
import { ProductResponse } from '../../models/product-response';

@Injectable({
    providedIn: 'root',
})
export class ProductService {
    private readonly productApiRoute = ApiRouteConstants.Product;

    constructor(private readonly http: HttpClient) {}

    /**
     * Retrieves all products from the API.
     */
    getAll(): Observable<ProductResponse[]> {
        return this.http.get<ProductResponse[]>(
            this.productApiRoute.getRootUrl(),
        );
    }
}
